import { Routes } from '@angular/router';
import { OrderComponent } from './features/order/order.component';
import { OrderDetailComponent } from './features/order-detail/order-detail.component';
import { MsalGuard } from '@azure/msal-angular';
import { DummyComponent } from './shared/components/dummy.component';
import { InspectorComponent } from './features/inspector/inspector.component';
import { BarcodesComponent } from './features/barcodes/barcodes.component';
import { CustomerFrontendManagementComponent } from './features/customer-frontend-management/customer-frontend-management.component';
import { customerAccessManagerGuard } from './core/customer-access-manager.guard';
import { KeycloakUserManagementComponent } from './features/keycloak-user-management/keycloak-user-management.component';
import { keycloakUserManagementGuard } from './core/keycloak-user-management.guard';

export const routes: Routes = [
  {
    path: 'order',
    component: OrderComponent,
    canActivate: [MsalGuard],
    title: 'Aufträge | IDR Backoffice',
  },
  { path: 'notKnownUrl', component: DummyComponent, title: 'Test Url' },
  {
    path: 'order/customer-frontend-management',
    component: CustomerFrontendManagementComponent,
    canActivate: [MsalGuard, customerAccessManagerGuard],
    title: 'Zugriffsverwaltung | IDR Backoffice',
  },
  {
    path: 'order/customer-frontend-management/group/new',
    loadComponent: () =>
      import('./features/customer-frontend-management/group-edit-page.component').then(
        (module) => module.GroupEditPageComponent
      ),
    canActivate: [MsalGuard, customerAccessManagerGuard],
    title: 'Neue Gruppe | IDR Backoffice',
  },
  {
    path: 'order/customer-frontend-management/group/:customerId/:groupId',
    loadComponent: () =>
      import('./features/customer-frontend-management/group-edit-page.component').then(
        (module) => module.GroupEditPageComponent
      ),
    canActivate: [MsalGuard, customerAccessManagerGuard],
    title: 'Gruppe bearbeiten | IDR Backoffice',
  },
  {
    path: 'order/:id',
    component: OrderDetailComponent,
    canActivate: [MsalGuard],
    title: 'Auftrag | IDR Backoffice',
  },
  {
    path: 'inspector',
    component: InspectorComponent,
    canActivate: [MsalGuard],
    title: 'Techniker | IDR Backoffice',
  },
  {
    path: 'barcodes',
    component: BarcodesComponent,
    canActivate: [MsalGuard],
    title: 'Barcodes | IDR Backoffice',
  },
  {
    path: 'user-management',
    component: KeycloakUserManagementComponent,
    canActivate: [MsalGuard, keycloakUserManagementGuard],
    title: 'Nutzerverwaltung | IDR Backoffice',
  },
];
